import Header from '../../components/Header'
import MediaMatch from '../../components/MediaMatch'
import Footer from '../../components/Footer'
import * as S from '../../styles/page-profile'

import { Breadcrumb, BreadcrumbItem } from '../../styles/breadcrumb'
import ProfileSideMenu from '../../components/MenuProfile'
import { ProfileTitle } from '../../components/FormChangePassword/styles'
import Filter from '../../components/Filter'
import IconFilter from '../../assets/img/icon-filter.svg'
import {
  FilterMobileButton,
  FilterMobileWrapper
} from '../../components/Filter/styles'
import { useState, useEffect } from 'react'
import FilterMobile from '../../components/FilterMobile'
import EmptyBox from '../../components/EmptyBox'
import { FilterDesktopContainer } from '../../styles/vendasPromovidas'
import Loader from '../../components/Loader'
import { useToast } from '../../hooks/toast'
import PaymentCardsModal from '../../components/MyPaymentCards/PaymentCardsModal'

import Paginator from '../../components/Paginator'
import FichaNegociacao from '../../components/FichaNegociacao'
import ProdutosEsgotadosModal from '../../components/MyPaymentCards/ProdutosEsgotadosModal'
import { useLocation } from 'react-router-dom'
import { getLocalStorageLog } from '../../utils/traceLogAcessos'
import { useQuery } from 'react-query'
import { GetNegociacaoRequest } from '../../types/negociacao'
import { getNegociacaoList } from '../../hooks/negociacao/useNegociacao'

declare global {
  interface Window {
    dataLayer: any[]
  }
}
function Negociacoes() {
  const { addToast }: any = useToast()

  const [showMenu, setShowMenu] = useState(false)
  const [showModalPayment, setShowModalPayment] = useState(false)
  const [showModalMessage, setShowModalMessage] = useState(false)
  const [esgotadoBoletoMessage, setEsgotadoBoletoMessage] = useState('')
  const [userCards, setUserCards] = useState([])
  const [pedido, setPedido] = useState('')

  const [loader, setLoader] = useState(false)

  const [filterParams, setFilterParams] = useState<GetNegociacaoRequest>({
    OpcaoFiltro: '',
    Numero: '',
    DataInicial: '',
    DataFinal: '',
    Page: 1,
    PageSize: 10
  })

  const { data, isLoading, isError } = useQuery(
    [
      'negociacao',
      filterParams.OpcaoFiltro,
      filterParams.Numero,
      filterParams.DataInicial,
      filterParams.DataFinal,
      filterParams.Page,
      filterParams.PageSize
    ],
    () =>
      getNegociacaoList(
        filterParams.OpcaoFiltro,
        filterParams.Numero,
        filterParams.DataInicial,
        filterParams.DataFinal,
        filterParams.Page,
        filterParams.PageSize
      ),
    {
      onError: () => {
        addToast({
          type: 'error',
          title: 'Não foi possível realizar busca',
          description: `Verifique os campos e tente novamente`
        })
      },
      staleTime: 1000 * 60 // 1 minuto,
    }
  )

  // console.log(store)

  const openMenu = () => {
    setShowMenu((prev) => !prev)
  }

  const openModalPayment = () => {
    setShowModalPayment((prev) => !prev)
  }

  const openModalMessage = () => {
    setShowModalMessage((prev) => !prev)
  }

  const fetch = async (
    tipoOperacao: string,
    n: string,
    di: string,
    df: string,
    pg: number
  ) => {
    try {
      setFilterParams({
        OpcaoFiltro: tipoOperacao,
        Numero: n,
        DataInicial: di,
        DataFinal: df,
        Page: pg
      })

      // console.log(filterParams)

      //Reseta o state com o pedidoId após primeiro fetch com o ID
    } catch (err) {
      addToast({
        type: 'error',
        title: 'Não foi possível realizar busca',
        description: `Verifique os campos e tente novamente`
      })

      return err
    }
  }

  const location = useLocation()

  //datalayer push on load
  useEffect(() => {
    if (!!loader)
      !!window.dataLayer && window.dataLayer.push({ event: 'negociacao' })
  }, [loader])

  useEffect(() => {
    getLocalStorageLog(location.pathname)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <S.Main>
      {isLoading && <Loader />}

      <PaymentCardsModal
        showModal={showModalPayment}
        setShowModal={setShowModalPayment}
        cardData={userCards}
        setUserCards={setUserCards}
        isLoading={isLoading}
        pedido={pedido}
        setPedido={setPedido}
        type="N"
        formas={undefined} // formas={formas}
      />

      <ProdutosEsgotadosModal
        message={esgotadoBoletoMessage}
        showModal={showModalMessage}
        setShowModal={setShowModalMessage}
      />

      <FilterMobile
        showMenu={showMenu}
        setShowMenu={setShowMenu}
        click={fetch}
        opcoes={[
          { value: '', label: 'Todas' },
          {
            value: 'NEGOCIACAO_REJEITADA',
            label: 'Negociação Rejeitada'
          },
          {
            value: 'NEGOCIACAO_AVALIADA',
            label: 'Negociação Avaliada'
          },
          {
            value: 'NEGOCIACAO_CANCELADA',
            label: 'Negociação Cancelada'
          },
          {
            value: 'NEGOCIACAO_PEDIDO',
            label: 'Negociação Convertida'
          },
          {
            value: 'NEGOCIACAO_AGUARDANDO',
            label: 'Negociação aguardando avaliação'
          }
        ]}
        pedido={undefined}
        gimplus={undefined}
        small={undefined}
        promotor={undefined}
      />
      <Header></Header>
      <S.Profile className="perfil">
        <S.PageContent className="page-content">
          <S.Wrapper className="wrapper">
            <S.ColGroup className="col-group">
              <ProfileSideMenu />
              <S.ProfileContent className="col-9">
                {/* Área para inserir os novo componentes criados para ficar ao lado do menu lateral de perfil */}
                <Breadcrumb>
                  <BreadcrumbItem>Inicio</BreadcrumbItem>
                  <BreadcrumbItem>Negociações</BreadcrumbItem>
                </Breadcrumb>

                <MediaMatch greaterThan="1171px">
                  <FilterDesktopContainer>
                    <ProfileTitle>Negociações</ProfileTitle>
                    <Filter
                      click={fetch}
                      opcoes={[
                        { value: '', label: 'Todas' },
                        {
                          value: 'NEGOCIACAO_REJEITADA',
                          label: 'Negociação Rejeitada'
                        },
                        {
                          value: 'NEGOCIACAO_AVALIADA',
                          label: 'Negociação Avaliada'
                        },
                        {
                          value: 'NEGOCIACAO_CANCELADA',
                          label: 'Negociação Cancelada'
                        },
                        {
                          value: 'NEGOCIACAO_PEDIDO',
                          label: 'Negociação Convertida'
                        },
                        {
                          value: 'NEGOCIACAO_AGUARDANDO',
                          label: 'Negociação aguardando avaliação'
                        }
                      ]}
                      pedido={undefined}
                      promotor={undefined}
                      small={undefined}
                      gimplus={undefined}
                      setShowMenu={undefined}
                      calendarModal={undefined}
                    />
                  </FilterDesktopContainer>
                </MediaMatch>

                <MediaMatch lessThan="large">
                  <FilterMobileWrapper>
                    <ProfileTitle>Negociações</ProfileTitle>
                    <FilterMobileButton
                      align={false}
                      onClick={(e) => {
                        e.preventDefault()
                        openMenu()
                      }}
                    >
                      <img src={IconFilter} alt="" />
                    </FilterMobileButton>
                  </FilterMobileWrapper>
                </MediaMatch>

                {!!isLoading ? (
                  <Loader></Loader>
                ) : (
                  <>
                    {data?.TotalCount === 0 && (
                      <EmptyBox>Você ainda não fez negociações :(</EmptyBox>
                    )}
                    <S.Fichas>
                      <FichaNegociacao
                        type="n"
                        showModal={openModalPayment}
                        showModalMessage={openModalMessage}
                        setEsgotadoBoletoMessage={setEsgotadoBoletoMessage}
                        pedidos={data}
                        setPedido={setPedido}
                      />
                    </S.Fichas>
                  </>
                )}
                <Paginator
                  setFilterParams={setFilterParams}
                  data={data}
                ></Paginator>
                {/* Fim da área de conteúdo da página */}
              </S.ProfileContent>
            </S.ColGroup>
          </S.Wrapper>
        </S.PageContent>
      </S.Profile>
      <Footer />
    </S.Main>
  )
}

export default Negociacoes
